import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery, baseQueryWithAuthHandling } from "../utils/utils";
import { InCabConfigResponse, InCabModifyPayload } from "../../pages/admins/in-cab-coaching/type";
import { API_ENDPOINTS } from "./endpoints";
import { API_METHODS } from "./constants";

export const InCabAPIs = createApi({
    reducerPath: "inCabApi",
    baseQuery: (args, api, extraOptions) =>
        baseQueryWithAuthHandling(
            appBaseQuery.withAuthJson,
            args,
            api,
            extraOptions
        ),
    endpoints: (builder) => ({

        // get all events for config
        getInCabConfig: builder.query<InCabConfigResponse,void>({
            query:() => {
                return {
                    url: API_ENDPOINTS.INCABCOACHING.INCAB_CONFIG,
                    method: API_METHODS.GET,
                };
            },
            transformErrorResponse(baseQueryReturnValue) {
                return baseQueryReturnValue;
            },
            transformResponse: (response: InCabConfigResponse) => {
                return response;
            },
        }),

        // modify event config
        modifyInCabConfig: builder.mutation<InCabConfigResponse, InCabModifyPayload>({
            query:(payload) => {
                return {
                    url: API_ENDPOINTS.INCABCOACHING.INCAB_CONFIG,
                    method: API_METHODS.PUT,
                    body: payload,
                };
            },
            transformErrorResponse(baseQueryReturnValue) {
                return baseQueryReturnValue;
            },
            transformResponse: (response: InCabConfigResponse) => {
                return response;
            },
        }),
    })
})

export const {
useGetInCabConfigQuery,
useModifyInCabConfigMutation
}= InCabAPIs;
